<template>
	<div class="aside">
		<el-menu class="el-menu-vertical-demo">
			<el-menu-item
				:index="item.router"
				v-for="(item, index) in asideData"
				:key="index"
				@click="handleMenuItemClick(item.router)"
			>
				<i class="el-icon-menu"></i>
				<span slot="title">{{ item.title }}</span>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
export default {
	name: "aslde",
	props: ["asideData"],
	data() {
		return {};
	},
	methods: {
		handleMenuItemClick(router) {
			// 检测如果点击的路由是addmessage_new，则新开一个浏览器tab展示

			if (router.indexOf("addmessage_new") !== -1) {
				const routeData = this.$router.resolve({
					path: router,
				});
				window.open(routeData.href, "_blank");
			} else {
				// 其他路由使用常规路由跳转
				this.$router.push(router);
			}
		},
	},
};
</script>

<style scoped></style>
<style>
.aside .el-menu-vertical-demo:not(.el-menu--collapse) {
	width: 140px;
	min-height: 400px;
}
</style>
